export default ['/assets/carousel-images/4c1_slide_1.png',
  '/assets/carousel-images/4c1_slide_2.png',
  '/assets/carousel-images/4c1_slide_3.png']



// WEBPACK FOOTER //
// ./client/app/modules/courses/4/4c1/i18n/carousel-images.js